import { render, staticRenderFns } from "./service-form-page.vue?vue&type=template&id=53bb8eb4&"
import script from "./service-form-page.vue?vue&type=script&lang=js&"
export * from "./service-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports